import {I18n, T} from '../../utils/I18n/I18n';
import React, {useEffect, useRef, useState} from 'react';
import {useCartContext} from '../../context/CartContext';
import {beginCheckoutEvent} from '../../hooks/useAnalytics';
import CheckoutContinueButton from './CheckoutContinueButton';
import './Checkout.scss';
import DeliveryMethods from "./DeliveryMethods/DeliveryMethods";

const CheckoutStep1Form = ({ onContinue }) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const {method: shippingMethod, setMethod, cart,loading} = useCartContext();

  const [currentMethod, setCurrentMethod] = useState(shippingMethod)
  const pickupRef = useRef();

  useEffect(() => {
    if (cart && cart.items) {
      beginCheckoutEvent(cart)
    }
  }, []);
  if (loading){
    return (<></>)
  }
  return (
    <>
      <div className="checkout__main">
        <I18n>
          {t => (
              <div className="checkout__main__method-title" title={t('cartSummary.typeOfDelivery')}>
                <T id="cartSummary.typeOfDelivery"/>
              </div>
          )}
        </I18n>
        <DeliveryMethods setMethod={setCurrentMethod} currentMethod={currentMethod} pickupRef={pickupRef} setIsDisabled={setIsDisabled}/>
      </div>

      <CheckoutContinueButton pickupRef={pickupRef} onContinue={onContinue} isDisabled={isDisabled}/>
    </>
  );
};

export default CheckoutStep1Form;
